import Vue from "vue"
import "../assets/css/style.scss"
import "../assets/css/main.scss"

import Notifications from "vue-notification"

import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import TextInput from "../components/input/TextInput";
import Button from "../components/button/Button";
import Select from "../components/select/Select";
import MultiSelect from "../components/select/MultiSelect.vue";
import Modal from "../components/modal/Modal";
import Toggle from "@/components/toggle/Toggle";
import TagsInput from "@/components/input/TagsInput";
import TextArea from "@/components/input/TextArea";
import Tabs from "@/components/tabs/Tabs";

import {Plugin} from "vue-fragment";
import TabHeader from "@/components/tabs/TabHeader";
import TabContent from "@/components/tabs/TabContent";
import DatePicker from "@/components/input/DatePicker/DatePicker";
import DateRangePicker from "@/components/input/DatePicker/DateRangePicker";
import TimePicker from "@/components/input/DatePicker/TimePicker";
import CheckBox from "@/components/input/CheckBox";
import DropDown from "@/components/dropdown/DropDown";

import AsyncLSelect from "@/components/select/LSelect/AsyncLSelect.vue";
import LSelectTree from "@/components/select/LSelect/LSelectTree.vue";
// import SelectTree from "@/components/select/SelectTree.vue";

Vue.use(Plugin);

const uiPlugin = {
    sweetalert() {
        console.log("Registering sweetalert library...")
        Vue.use(VueSweetalert2);
    },
    notification() {
        console.log("Registering notification library...")
        Vue.use(Notifications)
    },
    components() {
        Vue.component("TextInput", TextInput);
        Vue.component("Button", Button);
        Vue.component("Select", Select);
        Vue.component("MultiSelect", MultiSelect);
        // Vue.component("SelectTree", SelectTree);
        Vue.component("LSelect", AsyncLSelect);
        Vue.component("LSelectTree", LSelectTree);
        Vue.component("Modal", Modal);
        Vue.component("Toggle", Toggle);
        Vue.component("TagsInput", TagsInput);
        Vue.component("TextArea", TextArea);
        Vue.component("Tabs", Tabs);
        Vue.component("TabHeader", TabHeader);
        Vue.component("TabContent", TabContent);
        Vue.component("DatePicker", DatePicker);
        Vue.component("TimePicker", TimePicker);
        Vue.component("CheckBox", CheckBox);
        Vue.component("DropDown", DropDown);
        Vue.component("DateRangePicker", DateRangePicker);

    },
    register() {
        this.sweetalert();
        this.notification();
        this.components();
    }
}

export default uiPlugin;
